export const BOWLS_TYPES = {
    REUSABLE: "reusable",
    CLASSIC: "classic",
};
